const truncateText = (charLimit: number, text: string): string => {
  if (text.length > charLimit) {
    return `${text.substring(0, charLimit).trimEnd()}...`;
  }
  return text;
};

export default truncateText;
